import { render, staticRenderFns } from "./car-edit.vue?vue&type=template&id=28770ace&scoped=true&"
import script from "./car-edit.vue?vue&type=script&lang=js&"
export * from "./car-edit.vue?vue&type=script&lang=js&"
import style0 from "./car-edit.vue?vue&type=style&index=0&id=28770ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28770ace",
  null
  
)

export default component.exports